import {HttpLink, ApolloLink, from} from "@apollo/client";
import { ServerError } from "@apollo/client/link/utils";
import {setContext} from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import {ServiceContainer} from "../ServiceContainer";
import QueryService from "../QueryService";
import store from "../../store";
import { setIsAccountBlocked } from "../../reducers/app";
import { isTrialBlockedShow, isTrialEndedShow, subscriptionAccessVar } from "../../graphql/state";
import { isTrialBlocked, loadSubscriptionAccess } from "../subscriptionTrial";

export default class LinkProvider {
    public static getHttpLink() {
        return new HttpLink({
            uri: process.env.REACT_APP_BACKEND_ADDRESS + "/graphql",
            credentials: 'include',
        })

    }

    public static getContextLink(httpLink: HttpLink, token: string | null, urlPath: string) {
        let contextLink = setContext((_, { headers }) => {
            return {
                headers: {
                    ...headers,
                    ...(token ? { 'X-AUTH-TOKEN': token } : {}),
                    'URL-PATH': urlPath,
                },
            };
        });
        return contextLink.concat(httpLink);
    }

    public static getErrorLink(): ApolloLink {
    return onError(({ graphQLErrors, networkError }) => {
      const handleGraphQLError = (message?: string) => {
        if (message === "SUBSCRIPTION_REQUIRED") {
          void loadSubscriptionAccess().then((access) => {
            if (!access) return;
            subscriptionAccessVar(access);
            const blocked = isTrialBlocked(access);
            isTrialBlockedShow(blocked);
            isTrialEndedShow(blocked);
          });
        }
      };

      if (graphQLErrors) {
        for (const err of graphQLErrors) {
          console.error(`[GraphQL error]: ${err.message}`);
          handleGraphQLError(err.message);

          if (err.message === "You need to be logged to access this field") {
            window.location.href = `${process.env.REACT_APP_BACKEND_ADDRESS}/login`;
          }
          if (err.message === "Your account has been blocked.") {
            store.dispatch(setIsAccountBlocked(true));
          }
        }
      }

      if (networkError) {
        console.error(`[Network error]: ${networkError}`);

        if ('result' in networkError) {
          const { result, statusCode } = networkError as ServerError;
          if (result && typeof result === "object" && "errors" in result) {
            for (const error of result.errors as Array<{ message?: string }>) {
              handleGraphQLError(error.message);
            }
          }
          if (statusCode === 403 && result === "Your account has been blocked.") {
            store.dispatch(setIsAccountBlocked(true));
          }
        }
      }
    });
  }

    public static getCurrentLink() {
        const token = ServiceContainer.resolve<QueryService>('QueryService').token
        const urlPath = window.location.href;
        const httpLink = LinkProvider.getHttpLink();
        const contextLink = LinkProvider.getContextLink(httpLink, token, urlPath);
        const errorLink = LinkProvider.getErrorLink();

        return from([errorLink, contextLink]);
    }
}
